module.exports = __webpack_public_path__ + "static/appstore-9fed76f3e7bcc9bd7c85983e3da871dd.svg";